export const messages = {
  waitForAgreementToBeUploaded: 'Ожидается подготовка договора',
  waitForAgreementToBeSigned: 'Ожидайте подписание договора второй стороной',
  agreementIsSignedYouCanPerformTheService: 'Договор подписан, можете приступать к исполнению услуги',
  agreementIsSignedWaitToBeServed: 'Договор подписан, ожидайте исполнения услуги',
}
